import SponsorContent from './sponsorContent'

export default SponsorContent